(window.BWBlockReport = function ($, Behaviors) {
    "use strict";

    const module = {};

    function BWBlockReport() {
        const BWBlockReportSections = document.querySelectorAll('.BWBlockReport');

        BWBlockReportSections.forEach(section => {
            const tabsHolder = section.querySelector('.BWBlockReport__tabs');

            if (!tabsHolder) {
                return;
            }
            const allTabsContent = section.querySelectorAll('.BWBlockReport__content__tab');

            tabsHolder.addEventListener('click', e => {
                const {target} = e;

                if (!target.matches('.BWBlockReport__tabs__tab')) {
                    return;
                }

                const allTabs = section.querySelectorAll('.BWBlockReport__tabs__tab');

                allTabs.forEach(tab => {
                    tab.classList.remove('active');
                });

                allTabsContent.forEach(tab => {
                    tab.classList.remove('active');
                });

                const tabIndex = target.dataset.tabIndex;

                target.classList.add('active');

                const tabActive = section.querySelector(`.BWBlockReport__content__tab[data-tab-index="${tabIndex}"]`);

                console.log(tabActive);

                tabActive.classList.add('active');


            });

            allTabsContent.forEach(tab => {
                scrollOnMouse(tab);
            });
        });


        function scrollOnMouse(container) {
            let [firing, currPos, prevX] = [false, 0, 0];

            container.addEventListener("pointerdown", e => {
                prevX = e.clientX || e.touches[0].clientX;
                e.preventDefault();
                firing = true;
                e.target.style.cursor = 'grab';
            });

            container.addEventListener("pointerup", e => {
                e.target.style.cursor = 'initial';
            });

            container.addEventListener("pointermove", ({clientX: newX}) => {
                if (!firing) return;

                let newPos = currPos - (newX - prevX);

                prevX = newX;
                container.scrollTo(newPos, 0);
                currPos = newPos;
            });

            container.addEventListener("touchstart", e => {
                prevX = e.touches[0].clientX;
                e.preventDefault();
                firing = true;
                e.target.style.cursor = 'grab';
            });

            container.addEventListener("touchend", e => {
                e.target.style.cursor = 'initial';
            });

            container.addEventListener("touchmove", ({touches}) => {
                if (!firing) return;

                let newX = touches[0].clientX;
                let newPos = currPos - (newX - prevX);

                prevX = newX;
                container.scrollTo(newPos, 0);
                currPos = newPos;
            });

            container.addEventListener("pointerup", () => {
                firing = false;
            });

            container.addEventListener("pointerleave", () => {
                firing = false;
            });

            container.addEventListener("touchend", () => {
                firing = false;
            });

            container.addEventListener("touchcancel", () => {
                firing = false;
            });
        }
    }

    module.BWBlockReport = BWBlockReport;

    document.addEventListener('DOMContentLoaded', BWBlockReport);

    return module;

}(window.jQuery, window.Behaviors));
